import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { CloseIcon } from 'components/SvgIcon';
import DeleteBtnInModal from 'components/DeleteBtnInModal';

const CounselorDeleteProgramModal = ({ visible, onClose, onUpdate }) => {
    return (
        <Modal
            title={'担当企業/プログラム削除'}
            visible={visible}
            width={400}
            footer={null}
            closeIcon={<CloseIcon />}
            onCancel={() => onClose()}
        >
            <p>{'担当企業のプログラムを削除します。この操作はやり直しできません。よろしいですか？'}</p>
            <DeleteBtnInModal onClose={onClose} onUpdate={onUpdate} />
        </Modal>
    );
};

CounselorDeleteProgramModal.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUpdate: PropTypes.func.isRequired,
};

export default CounselorDeleteProgramModal;
